import { render, staticRenderFns } from "./positionDetails.vue?vue&type=template&id=2bd40cdd&scoped=true&"
import script from "./positionDetails.vue?vue&type=script&lang=js&"
export * from "./positionDetails.vue?vue&type=script&lang=js&"
import style0 from "./positionDetails.vue?vue&type=style&index=0&id=2bd40cdd&prod&scoped=true&lang=css&"
import style1 from "./positionDetails.vue?vue&type=style&index=1&id=2bd40cdd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd40cdd",
  null
  
)

export default component.exports